import { render, staticRenderFns } from "./starMember.vue?vue&type=template&id=a2cbc4de&scoped=true"
import script from "./starMember.vue?vue&type=script&lang=js"
export * from "./starMember.vue?vue&type=script&lang=js"
import style0 from "./starMember.vue?vue&type=style&index=0&id=a2cbc4de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cbc4de",
  null
  
)

export default component.exports